import React from 'react';
import { ReactGoogleReviews } from "react-google-reviews";
import "react-google-reviews/dist/index.css";

const Testimonials = () => {
  const featurableWidgetId = process.env.REACT_APP_FEATURABLE_WIDGET_ID;

  return (
    <section className="relative py-16 overflow-hidden bg-gray-50">
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-6">
          <h1 className="text-2xl font-medium text-gray-900 sm:text-4xl">
            Hear from our users
          </h1>
          <p className="mt-4 text-lg text-gray-600">
            Real testimonials from our community members.
          </p>
        </div>
        
        {featurableWidgetId && (
          <ReactGoogleReviews 
            layout="badge"
            featurableId={featurableWidgetId}
          />
        )}
      </div>
    </section>
  );
};

export default Testimonials;
